export enum ReasonForJoining {
    TO_BECOME_FREELANCER,
    FIND_MISSIONS,
    CENTRALIZE_MISSIONS,
    CURIOSITY,
}

export enum SeniorityLevel {
    NEW_FREELANCER = 'NEW_FREELANCER',
    FEW_JOBS_FREELANCER = 'FEW_JOBS_FREELANCER',
    ESTABLISHED_FREELANCER = 'ESTABLISHED_FREELANCER',
}
